import { Markets } from "../../types";

const MarketFilter = ({ markets, children }: {
    markets: Markets[],
    children: JSX.Element
}) => {
    const market = process.env.REACT_APP_MARKET as Markets | undefined;

    return (
        <>
            {market && markets.includes(market) && children}
        </>
    );
};

export default MarketFilter;
